import type { CheckoutCart } from "@dransay/api/models";
import { hasCrossSellingGroup } from "~/features/checkout/delivery/fulfillment-groups.resolver";
import {
	CHECKOUT_STEP_TO_TELEMETRY_CHECKOUT_STEP,
	resolveCrossSellTelemetryStep,
	type TELEMETRY_CHECKOUT_STEP,
} from "~/tooling/telemetry/checkout-step-sequence";
import type { CheckoutStep } from "./checkout.schemas";
import { CHECKOUT_STEP_NAMES } from "./constants";

/**
 * Which step a customer just completed by leaving `currentStep`, or null when
 * leaving the route is not itself a completion.
 *
 * Two steps are not named by the route they sit on, which is why this is not a
 * plain lookup in CHECKOUT_STEP_TO_TELEMETRY_CHECKOUT_STEP.
 */
export function resolveCompletedStepTitle(
	currentStep: CheckoutStep,
	cart: CheckoutCart | null | undefined,
): TELEMETRY_CHECKOUT_STEP | null {
	// Delivery completes once per package, which DeliveryStep emits as it
	// confirms each one. Leaving the route would otherwise re-report the first
	// package as if the whole step were a single completion.
	if (currentStep === CHECKOUT_STEP_NAMES.delivery) {
		return null;
	}

	// Cross-sell completes as "skip and continue" or as "continue" depending on
	// whether the basket gained an accessory, and analytics counts those
	// separately.
	if (currentStep === CHECKOUT_STEP_NAMES.crossSell) {
		return resolveCrossSellTelemetryStep(
			cart ? hasCrossSellingGroup(cart) : false,
		);
	}

	return CHECKOUT_STEP_TO_TELEMETRY_CHECKOUT_STEP[currentStep];
}
